class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
  }

  get input() {
    return this.querySelector('input[type="search"]');
  }

  get resetButton() {
    return this.querySelector('button[type="reset"]');
  }

  connectedCallback() {
    if (!this.listenersAttached) {
      this.listenersAttached = true;
      this.addEventListener('input', (event) => {
        if (event.target.matches('input[type="search"]')) {
          this.debouncedOnChange(event);
        }
      });

      setTimeout(() => {
        if (this.input?.form) {
          this.input.form.addEventListener('reset', this.onFormReset.bind(this));
        }
        this.initDynamicPlaceholder();
      }, 0);
    }
  }

  initDynamicPlaceholder() {
    if (!this.input) return;
    const staticPrefix = this.input.dataset.staticPrefix || 'Search for';
    const wordsSetting = this.input.dataset.dynamicWords || '';
    this.dynamicWords = wordsSetting.split(',').map((w) => w.trim()).filter(Boolean);

    if (this.dynamicWords.length === 0) return;

    this.staticPrefix = staticPrefix;
    this.wordIndex = 0;
    this.charIndex = 0;
    this.isDeleting = false;
    this.typingSpeed = 100;
    this.deletingSpeed = 50;
    this.pauseDuration = 1500;

    this.animatePlaceholder();
  }

  animatePlaceholder() {
    if (!this.input || !this.dynamicWords || this.dynamicWords.length === 0) return;

    const currentWord = this.dynamicWords[this.wordIndex % this.dynamicWords.length];

    if (this.isDeleting) {
      this.charIndex--;
    } else {
      this.charIndex++;
    }

    const currentText = currentWord.substring(0, this.charIndex);
    const fullPlaceholder = `${this.staticPrefix} ${currentText}`;

    this.input.setAttribute('placeholder', fullPlaceholder);
    const label = this.querySelector('.field__label');
    if (label) {
      label.textContent = fullPlaceholder;
    }

    let nextTimeout = this.isDeleting ? this.deletingSpeed : this.typingSpeed;

    if (!this.isDeleting && this.charIndex === currentWord.length) {
      nextTimeout = this.pauseDuration;
      this.isDeleting = true;
    } else if (this.isDeleting && this.charIndex === 0) {
      this.isDeleting = false;
      this.wordIndex++;
      nextTimeout = 400;
    }

    if (this.typingTimer) clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(() => this.animatePlaceholder(), nextTimeout);
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
